import React from 'react'
import PropTypes from 'prop-types'
import './SavingLabel.scss'
import CircularProgress from '@mui/material/CircularProgress'

function SavingLabel({ active = false }) {
  return active ? <><CircularProgress className="grid-icon" size={15} /> &nbsp; </> : null
}

SavingLabel.propTypes = {
  active: PropTypes.bool.isRequired
}

export default SavingLabel
